import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';
import { MatTooltipModule } from '@angular/material/tooltip';

import { InputModule } from '@app/modules/ui-components/components/input/input.module';
import { DashboardUserHeaderModule } from '@dashboards/components/dashboard-user-header/dashboard-user-header.module';
import { UnitDetailsDescriptionSectionModule } from '@portfolio/components/unit-details/components/unit-details-description-section/unit-details-description-section.module';
import { UnitDetailsInspectionsModule } from '@portfolio/components/unit-details/components/unit-details-inspections/unit-details-inspections.module';
import { UnitDetailsPicturesSectionModule } from '@portfolio/components/unit-details/components/unit-details-pictures-section/unit-details-pictures-section.module';
import { UnitDetailsPropertySectionModule } from '@portfolio/components/unit-details/components/unit-details-property-section/unit-details-property-section.module';
import { PipesModule } from '@shared/pipes/pipes.module';
import { DashboardContainerModule } from '@ui-components/components/dashboard-container/dashboard-container.module';
import { EmptyDataModule } from '@ui-components/components/empty-data/empty-data.module';
import { IconComponent } from '@ui-components/components/icon/icon.component';
import { InputAreaModule } from '@ui-components/components/input-area/input-area.module';
import { RadioButtonDropdownModule } from '@ui-components/components/radio-button-dropdown/radio-button-dropdown.module';

import { UnitDetailsComponent } from './unit-details.component';
import { PortfolioHeaderModule } from '../portfolio-header/portfolio-header.module';

@NgModule({
  declarations: [UnitDetailsComponent],
  imports: [
    CommonModule,
    PortfolioHeaderModule,
    InputModule,
    IconComponent,
    MatButtonModule,
    MatTableModule,
    MatSortModule,
    EmptyDataModule,
    DashboardContainerModule,
    DashboardUserHeaderModule,
    ReactiveFormsModule,
    InputAreaModule,
    PipesModule,
    UnitDetailsPicturesSectionModule,
    UnitDetailsPropertySectionModule,
    UnitDetailsDescriptionSectionModule,
    MatCheckboxModule,
    MatTooltipModule,
    MatProgressSpinnerModule,
    FormsModule,
    UnitDetailsInspectionsModule,
    RadioButtonDropdownModule,
  ],
})
export class UnitDetailsModule {}
